import React, { useState, useEffect } from 'react'
import { Link, Image } from 'newComponents'
import './styles.scss'

const PostDetails = (props) => {
  const [minsToRead, setMinsToRead] = useState(0)
  const { timestamp, hideDate, className, author, dataString } = props

  const authorUID = author?.document?.uid ? author?.document?.uid : '#'
  const authorObject = author?.document?.data || {}
  const { author_name: authorName, author_image: authorImage } = authorObject
  const authorText = authorName?.text ? authorName?.text : 'The LaunchDarkly Team'

  const hasAuthorImage = authorImage?.url
  const showTimeStamp = timestamp && !hideDate

  useEffect(() => {
    const wordsPerMinute = 200
    const textLength = dataString && dataString.split(' ').length // Split by words
    if (textLength > 0) {
      setMinsToRead(Math.ceil(textLength / wordsPerMinute))
    }
  }, [dataString])

  return (
    <div className={`post-details ${className || ''}`}>
      {(timestamp || authorText) && (
        <div className="post-details-author-timestamp">
          {hasAuthorImage && (
            <Link to={`/blog/author/${authorUID}`} className="post-details-author">
              <Image className="post-details-author-image" image={authorImage} />
            </Link>
          )}
          <div className="post-details-author-text">
            <div>
              {authorText && (
                <Link to={`/blog/author/${authorUID}`} className="post-details-author">
                  {`By ${authorText}`}
                </Link>
              )}
              {showTimeStamp && (
                <>
                  <span className="post-details-dot"> &nbsp; • &nbsp; </span>
                  <span className="post-details-timestamp">{timestamp}</span>
                </>
              )}
              {minsToRead ? <span className="post-details-readtime">{minsToRead} min read</span> : null}
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default PostDetails
